import { createScopedDescriptor, set } from 'quartz-core-utils/globalState/api';
import { createBrowserHistory } from 'history';
import { findBasename } from './findBasename';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');
export function initializeHistory(historyBasename, transformBasename) {
  let basename = findBasename(historyBasename, window.location.pathname, transformBasename);
  if (!basename) {
    if (typeof historyBasename === 'string') {
      // Kept for backwards compatibility but should eventually error always
      basename = historyBasename;
    }
    if (process.env.NODE_ENV !== 'production') {
      throw new Error('Browser url does not match `historyBasename`');
    }
  }
  const history = createBrowserHistory({
    basename
  });
  set(HISTORY_INSTANCE, history);
  return history;
}